<template>
    <div class="row teams-row mx-0">
        <div class="d-flex flex-column col-md-3 px-0 border-right py-3">
            <div class="team-actions px-2">
                <div
                    class="form-group d-flex justify-content-center align-items-center"
                >
                    <label class="mb-0 mr-2" for="pause"
                        >Show Unverified Users</label
                    >
                    <input
                        id="pause"
                        type="checkbox"
                        v-model="showUnverified"
                    />
                </div>
                <div class="input-and-submit-wrapper form-group">
                    <div class="form-icon">
                        <i class="fas fa-search"></i>
                    </div>
                    <input
                        type="text"
                        class="has-icon form-control"
                        name="group-name"
                        id="group-name"
                        v-model="userSearch"
                        placeholder="Search"
                    />
                </div>
            </div>
            <div class="teams vertical-scroll">
                <div
                    v-for="user in filteredUsers"
                    :key="user.id"
                    @click="selectUser(user)"
                    class="cursor-pointer px-2 py-2 team d-flex"
                    :class="{ active: activeUserId == user.id }"
                >
                    <span class="col">
                        {{ user.name }}
                    </span>
                    <!-- <div class="badges">
                        <i class="fa fa-pause" v-if="user.developers == 'NO_IMPORT'"></i>
                        <img src="/assets/img/ch-favicon.png" v-if="team.clickhint_plan" height="15" width="15" />
                    </div> -->
                </div>
            </div>
        </div>
        <div class="col-md-9 view-team py-3 px-4" v-if="activeUserId === null">
            <p class="thin-title text-center">
                Please select a User
            </p>
        </div>
        <div class="col-md-9 view-team py-3 px-4" v-else>
            <manage-user
                :user="activeUser"
                :teams="activeUserTeams"
                :partner="partner"
                @user-update-triggered="updateAll"
            />
        </div>
    </div>
</template>

<script>
import AdministrationMixin from "./AdministrationMixin";
import ManageUser from "./ManageUser";

export default {
    props: {
        partner: {
            type: Object,
            default: null
        }
    },
    components: {
        ManageUser
    },
    mixins: [AdministrationMixin],
    data() {
        return {
            users: [],
            activeUserTeams: [],
            showUnverified: false,
            userSearch: "",
            activeUserId: null
        };
    },
    mounted() {
        this.updateAll();
    },
    watch: {
        activeUser: {
            immediate: true,
            handler: function(newVal, oldVal) {
                this.getCurrentUser();
            }
        }
    },
    computed: {
        activeUser() {
            return this.activeUserId === null
                ? null
                : this.users.filter(user => {
                      return user.id == this.activeUserId;
                  })[0];
        },
        filteredUsers() {
            const needle = this.userSearch.toLowerCase();
            this.users.forEach(user => {
                user.name = user.name[0].toUpperCase() + user.name.slice(1);
                user.email = user.email.toLowerCase();
            });
            return this.users.filter(user => {
                if (user.verified == 0 && !this.showUnverified) {
                    return false;
                }
                if (
                    user.name.toLowerCase().includes(needle) ||
                    user.email.includes(needle)
                ) {
                    return true;
                }
            });
        }
    },
    methods: {
        updateAll() {
            this.getUsers();

            if (!this.activeUser) return;

            this.getCurrentUser();
        },
        getUsers() {
            const url = this.usersUrl;

            axios
                .get(url)
                .then(response => {
                    this.users = response.data;
                })
                .catch(error => {
                    swal("Oops!", "We couldn't load the users", "error");
                });
        },
        getCurrentUser() {
            if (!this.activeUserId) return;
            const url = this.usersUrl + `/${this.activeUserId}`;
            axios
                .get(url)
                .then(response => {
                    this.activeUserTeams = response.data;
                })
                .catch(error => {
                    swal("Oops!", "We couldn't load the user", "error");
                });
        },
        selectUser(user) {
            this.activeUserId = user.id;
        }
    }
};
</script>

<style scoped>
.teams-row {
    height: 70vh;
    overflow-y: hidden;
}
.teams-row .col-md-3 {
    height: 100%;
}
.teams-row .col-md-3 .teams {
    max-height: calc(100% - 90px);
    overflow-y: auto;
}
.team {
    font-weight: 600;
    color: #90919e;
}
.team.active {
    color: #00aef1;
    font-weight: 600;
    box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.19);
}
.fa-arrow-right {
    font-size: 10px;
    vertical-align: middle;
}
.view-team {
    overflow-y: auto;
    max-height: 100%;
}
</style>
